YP.GuestManager = function() {
    return {
        init: function() {
            if($('.js-form-guest').length > 0) {
               YP.GuestManager().initForm();
            }
        },
        initForm: function() {

            function format(state) {
                return state.text;
            }
            $('.js-form-guest').select2({
                minimumInputLength: 2,
                formatInputTooShort: function(term) {
                    return "Vous devez entrer au moins 2 caractères";
                },
                formatResult: format,
                formatSelection: format,
                formatNoMatches: function(term) {
                    return 'L\'organisateur que vous recherchez n\'existe pas, invitez le via son adresse email.'
                }
            });
        },
        enableInviteForm: function() {
            $('.js-form-guest').select2("close");
        }
    }
};

window.addEventListener("load", function(){
    YP.GuestManager().init();
});
